import { gql } from 'src/__generated__';

const UPDATE_ORGANIZATION_ACCESS = gql(`
  mutation UpdateOrganizationAccess($organizationId: Int!, $access: String) {
    updateOrganizationAccess(organizationId: $organizationId, access: $access) {
      success
    }
  }
`);

export default UPDATE_ORGANIZATION_ACCESS;
